import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var VISIT_AGAIN_ENABLED_PROP_NAME = 'data-visit-again';
var VISIT_AGAIN_TEXT_ATTR = 'data-visit-text';
var NOT_VISITED_ROW_SELECTOR = '[data-visit-again-row="false"]';
var NI_LINKS_SELECTOR = 'a.nilink';
var CTA_TEXT_SELECTOR = '[data-role="partner-cta"] span';
var VISIT_TXT_FALLBACK = 'Visit Again';
var initVisitAgain = function initVisitAgain() {
  var visitAgainEnabledCharts = document.querySelectorAll("[".concat(VISIT_AGAIN_ENABLED_PROP_NAME, "=\"true\"]"));

  var allPartnerLinks = _toConsumableArray(visitAgainEnabledCharts).flatMap(function (chart) {
    return _toConsumableArray(chart.querySelectorAll(NI_LINKS_SELECTOR));
  });

  if (allPartnerLinks.length === 0) {
    return;
  }

  var visitAgainText = visitAgainEnabledCharts[0].getAttribute(VISIT_AGAIN_TEXT_ATTR) || VISIT_TXT_FALLBACK;
  attachClickHandlersToPartnerLinks(allPartnerLinks, visitAgainText);
};

var attachClickHandlersToPartnerLinks = function attachClickHandlersToPartnerLinks(allPartnerLinks, visitAgainText) {
  var _iterator = _createForOfIteratorHelper(allPartnerLinks),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var partnerLink = _step.value;
      partnerLink.addEventListener('click', function (e) {
        var closestRow = e.currentTarget.closest(NOT_VISITED_ROW_SELECTOR);

        if (closestRow) {
          markRowAsVisited(closestRow, visitAgainText);
        } else {
          var legacyBrandPopup = e.currentTarget.closest('[data-hook="legacy-brand-page-wrap"]');

          if (legacyBrandPopup) {
            handleClickFromLegacyBrandPopup(legacyBrandPopup, visitAgainText);
          }
        }
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

var handleClickFromLegacyBrandPopup = function handleClickFromLegacyBrandPopup(legacyBrandPopup, visitAgainText) {
  var legacyBrandProductId = legacyBrandPopup.dataset.productId;
  var productRow = document.querySelector("[data-product-id=\"".concat(legacyBrandProductId, "\"]"));
  markRowAsVisited(productRow, visitAgainText, true);
};

var markRowAsVisited = function markRowAsVisited(closestRow, visitAgainText, isClickFromLegacyBrandPopup) {
  var ctaTextElement = closestRow === null || closestRow === void 0 ? void 0 : closestRow.querySelector(CTA_TEXT_SELECTOR);

  if (!closestRow || !ctaTextElement) {
    return;
  }

  var isLegacyPopupActiveOnProductRow = closestRow.dataset.legacyBrand === 'true';

  if (!isLegacyPopupActiveOnProductRow || isClickFromLegacyBrandPopup) {
    closestRow.dataset.visitAgainRow = 'true';
    ctaTextElement.innerHTML = visitAgainText;
  }
};

export { VISIT_AGAIN_ENABLED_PROP_NAME, VISIT_AGAIN_TEXT_ATTR, initVisitAgain };
